import { createApi } from "unsplash-js";

export const unsplashCreateApi = createApi({
  /* cspell:disable-next-line */
  accessKey: "p0q6Nj3ZsO9QR5Isvl-5go1PlNq8nhJfCFJ3mxmw1cQ",
});
